<header class="main__content__header modal-header">
    <h2 class="modal-title">Validade do Plano de Saúde</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="main__content__modal modal-body">
    <section *ngFor="let dependente of dependentes;">
        <span class="content-card-title">
            {{dependente.nome}}
        </span>
        <article class="content-card-descricao" *ngIf="dependente.template == 'alertaplano_universitario_20230525' ">
            A declaração de matrícula do dependente {{dependente.nome}} está para vencer e o prazo para o envio de uma
            nova
            declaração é até {{dependente.validade}}, caso contrário a mensalidade do mês subsequente passará a ser
            integral. Este é um benefício para filhos solteiros, com idade de 21 anos completos a 24 anos incompletos,
            caso
            seu dependente não atenda a essas regras passará para mensalidade integral no mês subsequente.
            <section class="content-form col-xl-4 col-lg-5 col-md-6 col-sm-12 mt-1">
                <form-input [labelInput]="'Upload do Documento'" [isMultiple]="true" [isRequired]="true"
                    (adicionar)="adicionarArquivos($event)">
                </form-input>
            </section>
            <section class="col-xl-12 p-0 content-form-lista" [@fadeIn]>
                <div class="lista-row mx-1" *ngFor="let itemFile of documentTypeList; let i = index" [@fadeIn]>
                    <span>
                        {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                    </span>
                    <div class="lista-actions">
                        <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile(i)"
                            [icon]="faSquareXmark"></fa-icon>
                    </div>
                </div>
            </section>
            <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1"
                (click)="encaminharDocumentos()">
                ENVIAR
            </button>
        </article>
        <article class="content-card-descricao" *ngIf="dependente.template == 'alertaplano_21anos_20230525' ">
            O dependente {{dependente.nome}}, está para completar <b>21 anos</b>, caso o dependente esteja estudando
            curso
            superior (graduação, pós ou mestrado) e seja solteiro tem até {{dependente.validade}} para enviar a
            declaração
            de matrícula atualizada contendo: curso, período letivo e semestre/ano que o dependente está matriculado,
            caso
            contrário a mensalidade do mês subsequente passará a ser integral.
        </article>
        <article class="content-card-descricao" *ngIf="dependente.template == 'alertaplano_39anos_20230525' ">
            Em decorrência da idade limite para permanência de filhos e enteados no plano de saúde. O seu/sua dependente
            {{dependente.nome}} será cancelado do plano de saúde no dia {{dependente.validade}}. Caso opte por fazer
            portabilidade para outro plano, o titular tem até 10 dias antes da data prevista para cancelamento para
            solicitar carta de portabilidade. Lembramos que só é possível solicitar a portabilidade se o plano ainda
            estiver
            ativo.
        </article>
        <article class="content-card-descricao" *ngIf="dependente.template == 'alertaplano_menorsobguarda_20230525' ">
            Em decorrência da idade limite para permanência de menor sob guarda no plano de saúde. O seu/sua dependente
            {{dependente.nome}} será cancelado do plano de saúde no dia {{dependente.validade}}. Caso opte por fazer
            portabilidade para outro plano, o titular tem até 10 dias antes da data prevista para cancelamento para
            solicitar carta de portabilidade. Lembramos que só é possível solicitar a portabilidade se o plano ainda
            estiver
            ativo.
        </article>
        <article class="content-card-descricao" *ngIf="dependente.template == 'alertaplano_universitario_20231101' ">
            A declaração de matricula do dependente {{dependente.nome}}, está para vencer e o prazo para envio de uma 
            nova declaração é até {{dependente.validade}}, caso contrário a mensalidade do mês subsequente passará a ser integral. 
            este é um benefício para filhos solteiros, com idade de 21 anos completos a 24 anos incompletos, caso seu dependente 
            não atenda a essas regras, passará para mensalidade integral  no mês subsequente. 
            A declaração de matrícula deverá ser enviada para o e-mail fundacao@fcopel.org.br
        </article>
        <div class="footer__modal">
            <a class="footer_modal__link" (click)="fecharModal()">
                Lembrar mais tarde!
            </a>
        </div>
    </section>
</main>